export default "__VITE_ASSET__CMMXcOHZ__"